// import React, { useState, useEffect } from "react";
// import "./Modals.css";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// export const AdsModalForPrevious = ({
//   show,
//   handleModal,
//   adsval,
//   state,
//   fornavigate,
//   close,
// }) => {
//   const navigate = useNavigate();
//   const [timeleft, setTimeleft] = useState(5);

//   useEffect(() => {
//     if (timeleft === 0) {
//       setTimeleft(null);
//       handleModal();
//       if (fornavigate === "From-pdf-link") {
//         navigate("/Pdfviewer", {
//           state: {
//             institute: state?.institute,
//             studymaterialname: state.studymaterialname,
//             modulepdf: state.modulepdf,
//             semestername: state.semestername,
//             subject: state.subject,
//             course: state.course,
//           },
//         });
//       }
//     }

//     if (!timeleft) return;

//     const intervalId = setInterval(() => {
//       setTimeleft(timeleft - 1);
//     }, 1000);

//     return () => {
//       clearInterval(intervalId);
//     };
//   }, [timeleft]);

//   const handleOverlayClick = (e) => {
//     e.stopPropagation();
//   };

//   return (
//     <>
//       {show && adsval == "1" && (
//         <>
//           <div className="modalContainer">
//             <div className="modal_show" onClick={(e) => e.stopPropagation()}>
//               <header className="modal_header">
//                 <h2 className="modal_header-title" style={{ color: "black" }}>
//                   {" "}
//                   Ads Page{" "}
//                 </h2>
//               </header>
//               <main className="modal_content" style={{ color: "black" }}>
//                 Ads Content
//               </main>
//               <footer className="modal_footer">
//                 <div className="model_button">
//                   <button
//                     className="modal-close"
//                     style={{ color: "black" }}
//                     onClick={() => close()}
//                   >
//                     Close
//                   </button>
//                 </div>
//                 {timeleft != null && (
//                   <h3 style={{color:"black"}}>00:{timeleft < 10 ? "0" + timeleft : timeleft}</h3>
//                 )}
//               </footer>
//             </div>
//           </div>
//           <div className="modal_overlay" onClick={handleOverlayClick} />
//         </>
//       )}
//     </>
//   );
// };

import React, { useState, useEffect } from "react";
import "./Modals.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AdsComponent from "../../AdsComponent/AdsComponent";

export const AdsModalForPrevious = ({
  show,
  handleModal,
  state,
  fornavigate,
  close,
}) => {
  const navigate = useNavigate();
  const [timeleft, setTimeleft] = useState(5);
  const [shouldShowAd, setShouldShowAd] = useState(false);

  // ✅ Only check ads flag from settings API
  useEffect(() => {
    const getAdsValue = async () => {
      try {
        const res = await axios.get(
          "https://rollingnotes.in/app/backend/api_v2/ads_setting.php"
        );
        if (res.status === 200 && res.data.ads === "1") {
          setShouldShowAd(true);
        } else {
          setShouldShowAd(false);
          close(); // auto-close if ad is disabled
        }
      } catch (err) {
        console.error("Error fetching ad settings:", err);
        setShouldShowAd(false);
        close();
      }
    };

    getAdsValue();
  }, []);

  // Countdown logic
  useEffect(() => {
    if (!shouldShowAd || timeleft === null) return;

    if (timeleft === 0) {
      setTimeleft(null);
      handleModal();

      if (fornavigate === "From-pdf-link") {
        navigate("/Pdfviewer", {
          state: {
            institute: state?.institute,
            studymaterialname: state.studymaterialname,
            modulepdf: state.modulepdf,
            semestername: state.semestername,
            subject: state.subject,
            course: state.course,
          },
        });
      }
    }

    const timer = setInterval(() => {
      setTimeleft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeleft, shouldShowAd]);

  const formattedTime = timeleft != null ? `00:${String(timeleft).padStart(2, "0")}` : "00:00";

  const handleOverlayClick = (e) => e.stopPropagation();

  return (
    // <>
    //   {show && shouldShowAd && (
    //     <>
    //       <div className="modal_overlay" onClick={handleOverlayClick}>
    //         <div className="modal_container" onClick={(e) => e.stopPropagation()}>
    //           <div className="modal_content">
    //             <div className="ad_container">
    //               <AdsComponent dataAdSlot="2597424317" />
    //               <div className="ad_text">Ad</div>
    //             </div>
    //             <div className="modal_footer">
    //               <button className="close_button" onClick={close}>
    //                 Close
    //               </button>
    //               <div className="timer">{formattedTime}</div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>

    //     </>
    //   )}
    // </>
    <>
    {shouldShowAd && show ? (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }} onClick={handleOverlayClick}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.4)',
          width: '90%',
          maxWidth: '550px',
          padding: '20px'
        }} onClick={(e) => e.stopPropagation()}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '400px', // Increased from 300px to 400px
              border: '1px dashed #ccc',
              backgroundColor: 'white',
              marginBottom: '20px',
              position: 'relative'
            }}>
              <AdsComponent dataAdSlot="2597424317" />
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: '#666',
                fontSize: '24px',
                zIndex: 0
              }}>Ad</div>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: '10px'
            }}>
              <button
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#f5f5f5',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontWeight: 500
                }}
                onClick={() => {
                  close();
                  
                }}
              >
                Close
              </button>
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{formattedTime}</div>
            </div>
          </div>
        </div>
      </div>
    ) : ""}</>
  );
};

